export function create(input: string): string {
  let hex = "";
  for (let i = 0; i < input?.length; i++) {
    hex += input.charCodeAt(i).toString(16).padStart(2, "0");
  }
  return hex;
}

export function reverse(hex: string | undefined): string {
  if (!hex) return "";
  let str = "";
  for (let i = 0; i < hex?.length; i += 2) {
    const byte = parseInt(hex.substr(i, 2), 16);
    str += String.fromCharCode(byte);
  }
  return str;
}
